import { CompanyStateInterface } from "./types";
import Company from "@/types/app/companies";


export default {
  
  setModalNewCompanyState(state: CompanyStateInterface, show: boolean) {
    state.modalNewCompany = show;
  },
  setModalCompanyState(state: CompanyStateInterface, show: boolean) {
    state.modalCompany = show;
  },
  setCompanyState(
    state: CompanyStateInterface,
    company: Company
  ) {
    state.company = company;
  },
  setCompaniesState(
    state: CompanyStateInterface,
    companies: Company[]
  ) {
    state.companies = companies;
  },
  setCompanySent(state: CompanyStateInterface, show: boolean) {
    state.companySent = show;
  }, 
};
